export * from './User'
export * from './Auth'
export * from './Hero'
export * from './Category'
export * from './Material'
export * from './Step'
export * from './StepType'
export * from './PresetGroup'
export * from './PresetCategory'
export * from './Preset'
export * from './BarcodeProductCategory'
export * from './BarcodeProduct'
export * from './News'
export * from './HeroConfig'



// WEBPACK FOOTER //
// ./src/graphql/mutations/index.js